import { Check, Pencil, Plus } from 'lucide-react'
import { Row } from 'src/shared/components/Semantic/all'
import { Button } from 'src/shared/components/ui/button'
import { useLocalization } from 'src/shared/hooks/useLocalization'

export const OrderTableAdminActions = ({
  isEditMode,
  onToggleEditMode,
  onAddRow,
  isAddRowPending,
}: {
  isEditMode: boolean
  onToggleEditMode: () => void
  onAddRow: () => void
  isAddRowPending: boolean
}) => {
  const { t } = useLocalization()

  return (
    <Row className="gap-2 items-center">
      <Button variant="ghost" size="sm" onClick={onToggleEditMode}>
        {isEditMode ? (
          <Check className="w-3.5 h-3.5 mr-1.5" />
        ) : (
          <Pencil className="w-3.5 h-3.5 mr-1.5" />
        )}
        {isEditMode ? t('Done', 'Klar') : t('Edit', 'Redigera')}
      </Button>

      {isEditMode && (
        <Button
          variant="secondary"
          size="sm"
          onClick={onAddRow}
          disabled={isAddRowPending}
        >
          <Plus className="w-3.5 h-3.5 mr-1.5" />
          {t('Add row', 'Lägg till rad')}
        </Button>
      )}

      {isEditMode && (
        <span className="text-[10px] leading-tight text-gray-500 text-center">
          {t('Enter all amounts in SEK', 'Skriv in alla belopp i SEK')}
        </span>
      )}
    </Row>
  )
}
